module.exports = __webpack_public_path__ + "static/media/acme.4311fde4.png";